// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b916856a","453":"f6651a0e","455":"fb90fe84"}[chunkId] + ".chunk.js";
};